import { useMutation, useQueryClient } from 'react-query';
import { invalidatePlannerTasks } from './invalidatePlannerTasks';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import {
  submitTaskAction,
  rejectLeaveRequest
} from 'RestAPIs/planner-messages';
import { MessageActionType } from '../types';
import { LEAVE_REQUEST_TASK_KEYS } from '../constants';

const useSubmitTaskAction = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (variables: {
      taskId: string;
      actionType: MessageActionType;
      note?: string;
      taskDefinitionKey?: string;
      leaveRequestId?: string;
      // Bulk callers show one summarising snackbar themselves; without this they
      // would stack a toast per item on top of it.
      silent?: boolean;
    }) => {
      const isLeaveReject =
        variables.actionType === MessageActionType.REJECT &&
        variables.taskDefinitionKey &&
        (LEAVE_REQUEST_TASK_KEYS as readonly string[]).includes(
          variables.taskDefinitionKey
        ) &&
        variables.leaveRequestId;

      if (isLeaveReject) {
        return rejectLeaveRequest({
          leaveRequestId: variables.leaveRequestId!,
          note: variables.note || ''
        });
      }

      return submitTaskAction(variables);
    },
    {
      onSuccess: (_data, variables) => {
        if (!variables.silent) showSuccessSnackbar();
        invalidatePlannerTasks(queryClient);
      },
      onError: (_error, variables) => {
        if (!variables.silent) showErrorSnackbar();
      }
    }
  );

  return { mutateAsync, isLoading };
};

export default useSubmitTaskAction;
